import * as React from 'react';
import LoaderService, { ILoaderService, loaderEvent } from '../../services/LoaderService';
import '../../styles/css/index.css';
import Spinner from '../Spinner';

export interface Props {

}

export interface State {
    loading: boolean;
}

class Loader extends React.Component<Props, State> {
    private readonly loaderService: ILoaderService;

    constructor(props: any) {
        super(props);
        this.loaderService = LoaderService.getInstance();
        this.loaderService.eventEmitter().on(loaderEvent, (loading: boolean) => this.setState({ loading }));

        this.state = {
            loading: false
        };
    }

    public render() {
        return (
            this.state.loading && (
                <div className='loader'>
                    <div className='spinner'>
                        <Spinner size={30}/>
                    </div>
                </div>
            )
        );
    }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/index.tsx